var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import Stretch from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        /* delete(id: number) {
          console.log('delete')
          return api.delete('stretches/' + id).then(this.splice)
        }
      */
        this.set = function (values) {
            _this.data = values.map(function (item) { return new Stretch(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.miniset = function (values) {
            _this.data = values.map(function (item) {
                var temp = __assign(__assign({}, item), { operationLineName: item.operationLine.name });
                delete temp.operationLine;
                return temp;
            });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            var data = new Stretch(value);
            _this.data.push(data);
            return data;
        };
        this.replace = function (value) {
            // console.log('replace - value', value)
            // console.log(this.data)
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
            return value;
        };
        this.splice = function (value) {
            // console.log('splice - value', value)
            // console.log(this.data)
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value; }), 1);
        };
        this.pull = function (stretch) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === stretch.id; }), 1);
        };
        this.saveCollaboratorPrices = function (data) {
            return api.post('stretches/collaboratorPrices', data);
        };
        this.saveAfiliatePrices = function (data) {
            return api.post('stretches/afiliatePrices', data);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('Stretches/Store - read')
        var eager = 
        // '[afiliatePrices, afiliatePassengerCategories, stretchOtas, headboard, tax, prices.[passengerCategory], vueltaPrices.[passengerCategory], operationLine.[businessUnit]]'
        '[marketing, collaboratorPrices, afiliatePrices, stretchOtas, headboard, tax, prices.[passengerCategory], vueltaPrices.[passengerCategory], operationLine.[businessUnit]]';
        if (id)
            return api.get("stretches_collaborator/".concat(id, "?eager=").concat(eager));
        return (api
            .get("stretches?eager=".concat(eager))
            // .then(this.set)
            .then(function (value) {
            // console.log('value', value)
            return _this.set(value);
            // return value
        }));
    };
    default_1.prototype.readSelect = function (select) {
        /*return api.get(`stretches?select=id&select=name&select=operationLine_id`).then(result => {
          return this.set(result)
        })*/
        return api.get("stretches?select=".concat(select, "&eager=[operationLine]")).then(this.miniset);
    };
    default_1.prototype.create = function (value) {
        if (value.values.hora) {
            console.log('borrando hora');
            value.values.hours = value.values.hora.hours;
            value.values.minutes = value.values.hora.minutes;
            delete value.values.hora;
        }
        return api.post('stretches', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        // @ts-ignore
        // console.log('update', Object.fromEntries(value))
        var _a;
        if ((_a = value.values) === null || _a === void 0 ? void 0 : _a.hora) {
            console.log('borrando hora');
            value.values.hours = value.values.hora.hours;
            value.values.minutes = value.values.hora.minutes;
            delete value.values.hora;
        }
        return api.put('stretches/' + id, value).then(this.replace).then(function (result) {
            // api.post(`cardExperiences/${result.id}`)
            return value;
        });
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('stretches/' + id, { disabled: disabled }).then(this.pull);
    };
    default_1.prototype.findBusinessunitByStretchId = function (id) {
        console.log('data: ', this.data);
        return this.data.filter(function (value) { return value.id === id; })[0];
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "miniset", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "splice", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/Store.ts
// module id = 712
// module chunks = 0